export type HideSpot = { id: string; x: number; y: number; w: number; h: number };

export const DEFAULT_HIDE_SPOTS: HideSpot[] = [
  { id: 'plant', x: 4, y: 45, w: 26, h: 16 },
  { id: 'shelf', x: 68, y: 44, w: 28, h: 19 },
  { id: 'cushion', x: 4, y: 58, w: 26, h: 12 },
];

export function hideSpotsFrom(
  meta: { hideSpots?: HideSpot[] } | undefined,
): HideSpot[] {
  return meta?.hideSpots ?? DEFAULT_HIDE_SPOTS;
}
